export enum ShoeSizeEnum {
  LESS_THAN_15 = "Menor que 15",
  SIZE_15 = "15",
  SIZE_16 = "16",
  SIZE_17 = "17",
  SIZE_18 = "18",
  SIZE_19 = "19",
  SIZE_20 = "20",
  SIZE_21 = "21",
  SIZE_22 = "22",
  SIZE_23 = "23",
  SIZE_24 = "24",
  SIZE_25 = "25",
  SIZE_26 = "26",
  SIZE_27 = "27",
  SIZE_28 = "28",
  SIZE_29 = "29",
  SIZE_30 = "30",
  SIZE_31 = "31",
  SIZE_32 = "32",
  SIZE_33 = "33",
  SIZE_34 = "34",
  SIZE_35 = "35",
  SIZE_36 = "36",
  SIZE_37 = "37",
  SIZE_38 = "38",
  SIZE_39 = "39",
  SIZE_40 = "40",
  SIZE_41 = "41",
  SIZE_42 = "42",
  SIZE_43 = "43",
  SIZE_44 = "44",
  SIZE_45 = "45",
  SIZE_46 = "46",
  GREATER_THAN_46 = "Maior que 46",
}

export type ShoeSizeKey = keyof typeof ShoeSizeEnum;

export enum ClothingSizeEnum {
  RN = "RN",
  PI = "PI",
  MI = "MI",
  GI = "GI",
  SIZE_1 = "1",
  SIZE_2 = "2",
  SIZE_3 = "3",
  SIZE_4 = "4",
  SIZE_6 = "6",
  SIZE_8 = "8",
  SIZE_10 = "10",
  SIZE_12 = "12",
  SIZE_14 = "14",
  SIZE_16 = "16",
  PP = "PP",
  P = "P",
  M = "M",
  G = "G",
  GG = "GG",
  XG = "XG",
  XXG = "XXG",
  XXXG = "XXXG",
}

export type ClothingSizeKey = keyof typeof ClothingSizeEnum;
